import React from "react";
import UnpublishedTable from "./UnpublishedTable";
import { useSelector } from "react-redux";
import { selUnpublishedInCurrent } from "../../slice/librarySlice";

export default function UnpublshTable(props) {
  const unPublishedContents = useSelector(selUnpublishedInCurrent);

  return <UnpublishedTable items={unPublishedContents} />;
}
